/**
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 **/

import React, { ReactElement, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { BrowserRestrictions } from '../../../types';
import { Namespaces } from '../../../i18n/i18n';
import { Browsers } from '../../../utils/constants';

type RestrictionCardDesktopProps = {
  className?: string,
  browsers: BrowserRestrictions[],
};

const defaultProps = {
  className: '',
};

const RestrictionCardDesktop: React.FC<RestrictionCardDesktopProps> = ({ className, browsers }: RestrictionCardDesktopProps): ReactElement => {
  const { t } = useTranslation(Namespaces.Common);

  const beautifyName = useCallback((name: string) => {
    switch (name) {
      case Browsers.Chrome: return 'Chrome';
      case Browsers.Firefox: return 'Firefox';
      case Browsers.Safari: return 'Safari';
      case Browsers.Edge: return 'Edge';
      case 'internetexplorer11': return 'Internet Explorer 11';
      default: return name;
    }
  }, []);

  return (
    <div className={className}>
      <h5 className="device-name">{t('restrictions.devices.desktop.title')}</h5>
      <ul className="os-browser-versions">
        {browsers.map(({ name, minVersion, excludedVersions }) => (
          <li key={`browser-${name}`}>
            <span>
              <span>{beautifyName(name)}</span>
              {' '}
              {minVersion === '' ? null : `${minVersion}+`}
            </span>
            <span>
              {excludedVersions?.length ? (
                <span>
                  {' '}
                  {t('restrictions.except')}
                  {' '}
                  {excludedVersions.join(', ')}
                </span>
              ) : null}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};

RestrictionCardDesktop.defaultProps = defaultProps;

export default RestrictionCardDesktop;
